import { render, staticRenderFns } from "./purchaseSuccess.vue?vue&type=template&id=a65108f0&scoped=true"
import script from "./purchaseSuccess.vue?vue&type=script&lang=js"
export * from "./purchaseSuccess.vue?vue&type=script&lang=js"
import style0 from "./purchaseSuccess.vue?vue&type=style&index=0&id=a65108f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65108f0",
  null
  
)

export default component.exports